import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedModule } from "../core/shared.module";
import { FormsModule } from "@angular/forms";
import { NoAuthGuard } from "./no-auth-guard.service";
import { AuthService } from '../core/services/auth.service';

import { TrimValueAccessorModule } from 'ng-trim-value-accessor';
import { LoginComponent } from "./login.component";
import { CommonService } from "../core/services/common.service";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from "./password-reset/password-reset.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        TrimValueAccessorModule
    ],
    declarations: [
        LoginComponent,
        ForgotPasswordComponent,
        PasswordResetComponent
    ],
    providers: [NoAuthGuard, AuthService, CommonService]
})
export class LoginModule {
    constructor(private commonService: CommonService) {
        this.commonService.populateGlobalVariables();
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/login/login.module.ts